/**
 * The right-hand dock the staff assistant and chat panels share (ENG-4537, ENG-4739). One panel is open at a
 * time: a panel registers how to minimize itself, and opening any panel minimizes every other one. The chrome
 * both panels draw with lives here too, so the matched pair cannot drift.
 */
const panels = new Map<string, () => void>()

export const registerDockedPanel = (name: string, minimize: () => void): (() => void) => {
    panels.set(name, minimize)

    return () => {
        panels.delete(name)
    }
}

/** Called on a panel's open path, before it publishes its own open state. */
export const openDockedPanel = (name: string): void => {
    for (const [other, minimize] of panels) {
        if (other !== name) {
            minimize()
        }
    }
}

/** A full page that takes the dock's place (the chat page, ENG-4740) minimizes every docked panel. */
export const minimizeDockedPanels = (): void => {
    for (const minimize of panels.values()) {
        minimize()
    }
}

/** The fixed right-edge overlay from `lg`, a full-width sheet below it. */
export const dockedPanelClass = 'fixed inset-y-0 right-0 z-30 flex w-full flex-col overflow-hidden border-storm-60 bg-white shadow-xl motion-safe:animate-assistant-in lg:w-[24rem] lg:border-l lg:shadow-[-4px_0_16px_rgba(31,37,48,0.06)] 2xl:w-[28rem]'

/** A panel header's icon buttons (Close, Back, Recent chats, New message). */
export const iconButtonClass = 'inline-flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-lg text-storm-40 hover:bg-storm-90 hover:text-storm-10 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-royal-20 disabled:cursor-no-drop disabled:opacity-50 disabled:hover:bg-transparent'

/** A panel header's title. */
export const panelTitleClass = 'text-sm! leading-5! font-semibold! tracking-normal! text-gray-900'

/** The sidebar and top bar launchers. */
export const launcherBase = 'h-11 shrink-0 cursor-pointer items-center rounded-lg border text-sm font-semibold focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-royal-20 focus-visible:ring-offset-2'

export const launcherOutlined = 'border-royal-10 bg-white text-royal-10 hover:bg-royal-60'

export const launcherFilled = 'border-royal-10 bg-royal-10 text-white'
